import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { Trophy, Calendar, Users, Globe, HelpCircle, Home, Menu, X, Star } from 'lucide-react';

// Pages
import HomePage from './pages/HomePage';
import WK2026Page from './pages/WK2026Page';
import WedstrijdenPage from './pages/WedstrijdenPage';
import OranjePage from './pages/OranjePage';
import NieuwsPage from './pages/NieuwsPage';
import StadionsPage from './pages/StadionsPage';
import OverWKPage from './pages/OverWKPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        {/* Navigation */}
        <nav className="bg-gradient-to-r from-amber-600 to-orange-600 text-white shadow-lg sticky top-0 z-50">
          <div className="container mx-auto px-4 py-4">
            <div className="flex justify-between items-center">
              <Link to="/" className="text-2xl font-bold flex items-center">
                <Trophy className="mr-2" />
                WK Informatie
              </Link>
              <div className="hidden md:flex space-x-6">
                <Link to="/" className="hover:text-amber-200 transition flex items-center">
                  <Home className="mr-1" size={18} /> Home
                </Link>
                <Link to="/wk-2026" className="hover:text-amber-200 transition flex items-center">
                  <Trophy className="mr-1" size={18} /> WK 2026
                </Link>
                <Link to="/wedstrijden" className="hover:text-amber-200 transition flex items-center">
                  <Calendar className="mr-1" size={18} /> Wedstrijden
                </Link>
                <Link to="/oranje" className="hover:text-amber-200 transition flex items-center">
                  <Users className="mr-1" size={18} /> Oranje
                </Link>
                <Link to="/nieuws" className="hover:text-amber-200 transition flex items-center">
                  <Star className="mr-1" size={18} /> Nieuws
                </Link>
                <Link to="/stadions" className="hover:text-amber-200 transition flex items-center">
                  <Globe className="mr-1" size={18} /> Stadions
                </Link>
                <Link to="/over-wk" className="hover:text-amber-200 transition flex items-center">
                  <HelpCircle className="mr-1" size={18} /> Geschiedenis
                </Link>
              </div>
              <div className="flex items-center space-x-4">
                <Link to="/contact" className="hover:text-amber-200 transition">Contact</Link>
              </div>
              <button className="md:hidden">
                <Menu size={24} />
              </button>
            </div>
          </div>
        </nav>

        {/* Main Content */}
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/wk-2026" element={<WK2026Page />} />
            <Route path="/wedstrijden" element={<WedstrijdenPage />} />
            <Route path="/oranje" element={<OranjePage />} />
            <Route path="/nieuws" element={<NieuwsPage />} />
            <Route path="/stadions" element={<StadionsPage />} />
            <Route path="/over-wk" element={<OverWKPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>

        {/* Footer */}
        <footer className="bg-gray-900 text-white py-12 mt-20">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
              <div>
                <h3 className="text-xl font-bold mb-4 flex items-center">
                  <Book className="mr-2" /> WK Informatie
                </h3>
                <p className="text-gray-400">
                  Uw betrouwbare bron voor informatie over werk, inkomen, en uitkeringen in Nederland.
                </p>
              </div>
              <div>
                <h4 className="font-bold mb-4">Categorieën</h4>
                <ul className="space-y-2 text-gray-400">
                  <li><Link to="/artikelen?category=werk" className="hover:text-amber-400">Werk & Arbeid</Link></li>
                  <li><Link to="/artikelen?category=inkomen" className="hover:text-amber-400">Inkomen & Loon</Link></li>
                  <li><Link to="/artikelen?category=uitkering" className="hover:text-amber-400">Uitkeringen</Link></li>
                  <li><Link to="/artikelen?category=belasting" className="hover:text-amber-400">Belastingen</Link></li>
                </ul>
              </div>
              <div>
                <h4 className="font-bold mb-4">Handige Links</h4>
                <ul className="space-y-2 text-gray-400">
                  <li><Link to="/tools" className="hover:text-amber-400">Rekentools</Link></li>
                  <li><Link to="/over-ons" className="hover:text-amber-400">Over Ons</Link></li>
                  <li><Link to="/contact" className="hover:text-amber-400">Contact</Link></li>
                  <li><Link to="/faq" className="hover:text-amber-400">Veelgestelde Vragen</Link></li>
                </ul>
              </div>
              <div>
                <h4 className="font-bold mb-4">Contact</h4>
                <ul className="space-y-2 text-gray-400">
                  <li>📧 info@wkinformatie.nl</li>
                  <li>📞 085-123 456 78</li>
                  <li>📍 Amsterdam, Nederland</li>
                </ul>
              </div>
            </div>
            <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
              <p>&copy; 2026 WK Informatie. Alle rechten voorbehouden.</p>
            </div>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;